import { render } from "./OrderCellEmailList.vue?vue&type=template&id=113b28ef&scoped=true"
import script from "./OrderCellEmailList.vue?vue&type=script&lang=js"
export * from "./OrderCellEmailList.vue?vue&type=script&lang=js"

import "./OrderCellEmailList.vue?vue&type=style&index=0&id=113b28ef&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113b28ef"]])

export default __exports__